import { render, staticRenderFns } from "./ApprovalMenuChip.vue?vue&type=template&id=2e792c14&scoped=true"
import script from "./ApprovalMenuChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApprovalMenuChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ApprovalMenuChip.vue?vue&type=style&index=0&id=2e792c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@3.6.2_vue-template-compiler@2.7.16_webpack@5.103.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e792c14",
  null
  
)

export default component.exports